import { SchedulerItemOnMachine } from './item-on-machine';
import { SchedulerMachineSubWorkOrder } from './sub-machine';
import { SchedulerSubWorkOrder } from './sub-work-order';

export class SchedulerSubWorkOrderOnMachine extends SchedulerItemOnMachine {
  machine: SchedulerMachineSubWorkOrder;
  subWorkOrderId: number;
  get itemId(): number {
    return this.subWorkOrderId;
  }

  subWorkOrder: SchedulerSubWorkOrder = undefined;
  get item(): SchedulerSubWorkOrder {
    return this.subWorkOrder;
  }
}
